import React from 'react'

import ReOrderItems from 'crm-components/reorder-items'

export default () => {
    return <ReOrderItems resolveType="Country" />
}
